
'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('AuditoriaAplicacaoService', function($http) {
  const patch = function(id, payload) {
    return $http.patch(`${SERVER}v1/auditoria_aplicacoes/${id}`, payload);
  };

  return {
    get: function(id) {
      return $http.get(`${SERVER}v1/auditoria_aplicacoes/${id}`);
    },

    aprove: function(aplicacao, apropriacaoId) {
      const payload = {
        aplicacao_auditada: {
          situacao: 'aprovado',
          apropriacao_id: apropriacaoId || null
        }
      };

      return patch(aplicacao.id, payload);
    },

    reject: function(aplicacao) {
      const payload = {
        aplicacao_auditada: {
          situacao: 'rejeitado'
        }
      };

      return patch(aplicacao.id, payload);
    },

    save: function(id, aplicacao) {
      let copied = angular.copy(aplicacao);
      copied.params.safraId = (aplicacao.safra || {}).id;
      if (aplicacao.tipoOperacao !== 'operacao_correcao_solo' &&
        aplicacao.tipoOperacao !== 'operacao_tratamento_semente') {
        copied.params.atividade = {
          id: aplicacao.atividade.id,
          atividade: aplicacao.atividade.descricao
        };
        delete copied.atividade;
      }

      delete copied.safra;
      delete copied.recommendation;
      copied = this.setDates(copied);

      const payload = {
        aplicacao_auditada: {
          objeto: JSON.stringify(copied)
        }
      };

      return patch(id, payload);
    },

    setDates(copied) {
      if (copied.atributo_attributes) { // tratamento de sementes
        copied.dataInicio = moment(copied.atributo_attributes.data_hora_inicio).format(MOMENT_DATE_ENGLISH_FORMAT);
        copied.atributo_attributes.data_hora_fim = `${moment(
          copied.atributo_attributes.data_hora_fim
        ).format(MOMENT_DATE_ENGLISH_FORMAT)} ${copied.hr_fim}`;

        copied.atributo_attributes.data_hora_inicio = `${moment(
          copied.atributo_attributes.data_hora_inicio
        ).format(MOMENT_DATE_ENGLISH_FORMAT)} ${copied.hr_ini}`;
      } else { // outras aplicações
        copied.dt_ini = moment(copied.dt_ini).format(MOMENT_DATE_ENGLISH_FORMAT);
        copied.dt_fim = moment(copied.dt_fim).format(MOMENT_DATE_ENGLISH_FORMAT);
        copied.iniciado_em = `${copied.dt_ini} ${copied.hr_ini}`;
        copied.encerrado_em = `${copied.dt_fim} ${copied.hr_fim}`;
      }
      delete copied.hr_ini;
      delete copied.hr_fim;
      return copied;
    }
  };
});
